import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {MvsCrudService} from 'features/core/shared/service/crud/mvs-crud.service';

/**
* CRUD service for cn.CommissionRule.
* Provides getObjectComponent() so the framework routes clicks on CommissionRule rows
* to CnCommissionRuleObjectComponent (CONFIG-015, 4-step click-chain).
* The actual component class reference is registered via entity-provider objectComponent[]
* to keep this file free of UI imports and avoid circular dependencies.
*/
@Injectable({
    providedIn: 'root'
})
export class CommissionRuleService extends MvsCrudService {

    constructor(protected override http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/cn/commissionRules');
    }

    getObjectIcon(): string {
        return 'fa-solid fa-sliders';
    }

    /**
     * Human-readable entity labels [singular, plural].
     * Element [0] is the singular label consumed by the core CRUD dialog title
     * (MvsCoreService.getObjectLabels(objectType)?.[0]) so the create/edit dialog
     * shows "Provisionsregel anlegen" / "Provisionsregel bearbeiten" instead of
     * the literal field name. These are entity labels, NOT field names.
     */
    getObjectLabels(): string[] {
        return ['Provisionsregel', 'Provisionsregeln'];
    }

}
